import { omniAtom } from "src/utils/atoms";

/**
 * "Next → Generate new merchflow" from a CDT version. Read by the create
 * flow to preselect the category and the stores that use the version, and
 * cleared when that flow closes so the next open starts clean.
 */
export interface CdtVersionContext {
  categoryId: number;
  treeId: number;
  treeName: string;
  /** Stores that resolve to the version (pinned or via the primary). */
  storeCodes: string[];
  /** The category's codes, so the create flow can pick it in the merchflow lists. */
  categoryCode?: string;
  categoryGroup?: string;
}

export const cdtVersionContextAtom = omniAtom({
  key: "cdt/versionContext",
  value: null as CdtVersionContext | null,
});

/**
 * Set when the create flow started from a CDT version proceeds to its base
 * planogram, so the Generate dialog there opens with "Primary / pinned CDT"
 * preselected. Consumed (cleared) by that dialog's opener.
 */
export interface PendingGenerationCdtSource {
  merchflowId: number;
  source: "CATEGORY_TREE";
}

export const pendingGenerationCdtSourceAtom = omniAtom({
  key: "cdt/pendingGenerationCdtSource",
  value: null as PendingGenerationCdtSource | null,
});
